(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents, currency = window.Shopify?.currency?.active || 'EUR') =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(cents / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[char]);

  const header = document.querySelector('[data-site-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mainNav = document.querySelector('[data-main-nav]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-header-search]');
  const searchClose = document.querySelector('[data-search-close]');
  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    searchToggle?.setAttribute('aria-expanded', 'false');
  };
  const setMenuOpen = (open) => {
    mainNav?.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    menuToggle?.setAttribute('aria-expanded', String(open));
    menuToggle?.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    if (open) {
      closeSearch();
      window.requestAnimationFrame(() => mainNav?.querySelector('a')?.focus());
    }
  };
  menuToggle?.addEventListener('click', () => {
    const open = !mainNav?.classList.contains('is-open');
    setMenuOpen(open);
  });
  mainNav?.addEventListener('click', (event) => {
    if (event.target.closest('a')) setMenuOpen(false);
  });
  searchToggle?.addEventListener('click', () => {
    const open = searchPanel?.hidden ?? true;
    if (searchPanel) searchPanel.hidden = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) searchPanel?.querySelector('input[type="search"]')?.focus();
  });
  searchClose?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSearch();
    setMenuOpen(false);
    if (cartDialog?.open) cartDialog.close();
  });
  window.addEventListener('resize', () => { if (window.innerWidth > 1040) setMenuOpen(false); }, { passive: true });
  window.addEventListener('scroll', () => header?.classList.toggle('is-scrolled', window.scrollY > 20), { passive: true });

  const cartDialog = document.querySelector('#SomCart');
  const cartBody = document.querySelector('[data-cart-body]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const cartButton = document.querySelector('[data-cart-open]');
    cartButton?.setAttribute('aria-label', `Warenkorb mit ${cart.item_count} Artikeln öffnen`);
    if (!cartBody || !cartFooter) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="empty-cart"><span>✦</span><strong>Hier ist noch Platz zum Wachsen.</strong><p>Entdecke eine Karte für deinen nächsten besonderen Moment.</p><a class="button button--light" href="/collections/all">Karten entdecken</a></div>';
      cartFooter.hidden = true;
      return;
    }
    cartBody.innerHTML = cart.items.map((item) => `<article class="cart-line" data-cart-key="${escapeHtml(item.key)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="90" height="110">` : ''}<div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a><small>${escapeHtml(item.variant_title || 'Saatpapierkarte')}</small>${Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith('_')).slice(0, 3).map(([key, value]) => `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`).join('')}<div class="qty"><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Menge verringern">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Menge erhöhen">＋</button></div></div><b>${money(item.final_line_price, cart.currency)}</b></article>`).join('');
    cartFooter.hidden = false;
    const total = cartFooter.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price, cart.currency);
  };
  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async () => {
    try { await getCart(); } catch (_) {}
    cartDialog?.showModal();
  }));
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => cartDialog?.close());
  cartDialog?.addEventListener('click', (event) => { if (event.target === cartDialog) cartDialog.close(); });
  cartBody?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.cartChange, quantity: Number(button.dataset.quantity) }) });
      if (!response.ok) throw new Error();
      renderCart(await response.json());
    } catch (_) { button.disabled = false; }
  });
  document.querySelectorAll('.som-ajax-product-form').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const original = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt …'; }
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error();
      await getCart();
      cartDialog?.showModal();
    } catch (_) {
      window.location.href = form.action;
    } finally {
      if (button) { button.disabled = false; button.innerHTML = original; }
    }
  }));

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      if (main) { main.src = thumb.dataset.image; main.srcset = ''; }
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    }));
  });

  const sender = document.querySelector('[data-direct-sender]');
  if (!sender) return;

  const form = sender.querySelector('[data-sender-form]');
  const alert = sender.querySelector('[data-sender-alert]');
  const fields = [...sender.querySelectorAll('[data-recipient-field]')];
  const emptyRecipient = () => ({ design: 'Vintage Herz', name: '', company: '', street: '', zip: '', city: '', country: 'Deutschland', date: '', message: '' });
  let quantity = 1;
  let recipients = [emptyRecipient()];
  let activeRecipient = 0;
  const priceFor = (amount) => amount >= 25 ? 3.99 : amount >= 10 ? 4.49 : amount >= 5 ? 4.99 : amount >= 3 ? 5.49 : 5.99;
  const formatEuros = (value) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
  const dateLabel = (value) => value ? new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(`${value}T12:00:00`)) : 'noch offen';
  const minimumDate = () => {
    const date = new Date();
    let added = 0;
    while (added < 3) { date.setDate(date.getDate() + 1); if (date.getDay() !== 0 && date.getDay() !== 6) added += 1; }
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 10);
  };
  const dateInput = sender.querySelector('[data-recipient-field="date"]');
  if (dateInput) dateInput.min = minimumDate();
  const showAlert = (message = '') => {
    if (!alert) return;
    alert.textContent = message;
    alert.hidden = !message;
    if (message) alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };
  const complete = (recipient) => recipient.design && recipient.name.trim() && recipient.street.trim() && recipient.zip.trim() && recipient.city.trim() && recipient.country.trim() && recipient.date && recipient.message.trim();
  const setQuantity = (next, custom = false) => {
    quantity = Math.max(1, Math.min(50, Math.round(Number(next) || 1)));
    while (recipients.length < quantity) recipients.push(emptyRecipient());
    recipients = recipients.slice(0, quantity);
    activeRecipient = Math.min(activeRecipient, quantity - 1);
    sender.querySelectorAll('[data-sender-quantity]').forEach((button) => button.classList.toggle('is-active', Number(button.dataset.senderQuantity) === quantity && !custom));
    sender.querySelector('[data-sender-custom]')?.classList.toggle('is-active', custom);
    const customWrap = sender.querySelector('[data-custom-quantity]');
    if (customWrap) customWrap.hidden = !custom;
    const input = sender.querySelector('[data-quantity-input]');
    if (input) input.value = quantity;
    updateTotals();
    renderRecipient();
  };
  const updateTotals = () => {
    const unit = priceFor(quantity);
    const total = unit * quantity;
    const noun = quantity === 1 ? 'Karte' : 'Karten';
    const summary = sender.querySelector('[data-sender-summary]');
    const totalNode = sender.querySelector('[data-sender-total]');
    const finalSummary = sender.querySelector('[data-final-summary]');
    const finalTotal = sender.querySelector('[data-final-total]');
    if (summary) summary.textContent = `${quantity} ${noun} · ${formatEuros(unit)} je Karte`;
    if (totalNode) totalNode.textContent = formatEuros(total);
    if (finalSummary) finalSummary.textContent = `${quantity} personalisierte ${noun}`;
    if (finalTotal) finalTotal.textContent = formatEuros(total);
  };
  const renderRecipient = () => {
    const recipient = recipients[activeRecipient];
    const tabs = sender.querySelector('[data-recipient-tabs]');
    if (tabs) tabs.innerHTML = recipients.map((item, index) => `<button type="button" class="${index === activeRecipient ? 'is-active' : ''}" data-recipient-tab="${index}"><span>Karte ${index + 1}</span><small>${escapeHtml(item.name || 'Offen')}</small></button>`).join('');
    fields.forEach((field) => { field.value = recipient[field.dataset.recipientField] || ''; });
    sender.querySelectorAll('input[name="sender-design"]').forEach((input) => { input.checked = input.value === recipient.design; });
    const remove = sender.querySelector('[data-recipient-remove]');
    if (remove) { remove.hidden = recipients.length === 1; remove.textContent = `Karte ${activeRecipient + 1} entfernen`; }
    const count = sender.querySelector('[data-message-count]');
    if (count) count.textContent = recipient.message.length;
    sender.querySelector('[data-preview-name]').textContent = `Für ${recipient.name || 'einen lieben Menschen'}`;
    sender.querySelector('[data-preview-design]').textContent = recipient.design;
    sender.querySelector('[data-preview-message]').textContent = recipient.message || 'Deine persönliche Nachricht erscheint hier …';
    sender.querySelector('[data-preview-date]').textContent = `Live-Vorschau · Versand am ${dateLabel(recipient.date)}`;
  };
  const showStep = (step) => {
    sender.querySelectorAll('[data-sender-step]').forEach((section) => section.classList.toggle('is-active', Number(section.dataset.senderStep) === step));
    sender.querySelectorAll('[data-sender-progress]').forEach((button) => {
      const number = Number(button.dataset.senderProgress);
      button.classList.toggle('is-active', number === step);
      button.disabled = number > step;
    });
    showAlert('');
    sender.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  sender.querySelectorAll('[data-sender-quantity]').forEach((button) => button.addEventListener('click', () => setQuantity(button.dataset.senderQuantity)));
  sender.querySelector('[data-sender-custom]')?.addEventListener('click', () => setQuantity(quantity, true));
  sender.querySelector('[data-quantity-minus]')?.addEventListener('click', () => setQuantity(quantity - 1, true));
  sender.querySelector('[data-quantity-plus]')?.addEventListener('click', () => setQuantity(quantity + 1, true));
  sender.querySelector('[data-quantity-input]')?.addEventListener('change', (event) => setQuantity(event.target.value, true));
  sender.querySelector('[data-recipient-tabs]')?.addEventListener('click', (event) => { const button = event.target.closest('[data-recipient-tab]'); if (!button) return; activeRecipient = Number(button.dataset.recipientTab); renderRecipient(); });
  sender.querySelector('[data-recipient-add]')?.addEventListener('click', () => { if (recipients.length >= 50) return; recipients.push(emptyRecipient()); quantity = recipients.length; activeRecipient = quantity - 1; setQuantity(quantity, true); });
  sender.querySelector('[data-recipient-remove]')?.addEventListener('click', () => { if (recipients.length === 1) return; recipients.splice(activeRecipient, 1); quantity = recipients.length; activeRecipient = Math.min(activeRecipient, quantity - 1); setQuantity(quantity, ![1, 3, 5, 10].includes(quantity)); });
  fields.forEach((field) => field.addEventListener('input', () => { recipients[activeRecipient][field.dataset.recipientField] = field.value; renderRecipient(); }));
  sender.querySelectorAll('input[name="sender-design"]').forEach((input) => input.addEventListener('change', () => { if (!input.checked) return; recipients[activeRecipient].design = input.value; renderRecipient(); }));
  sender.querySelectorAll('[data-sender-back]').forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.senderBack))));
  sender.querySelector('[data-sender-next="2"]')?.addEventListener('click', () => showStep(2));
  sender.querySelector('[data-sender-next="3"]')?.addEventListener('click', () => {
    const invalid = recipients.findIndex((recipient) => !complete(recipient));
    if (invalid >= 0) { activeRecipient = invalid; renderRecipient(); showAlert(`Bitte vervollständige zuerst die Angaben für Karte ${invalid + 1}.`); return; }
    showStep(3);
  });
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const invalid = recipients.findIndex((recipient) => !complete(recipient));
    if (invalid >= 0) { activeRecipient = invalid; renderRecipient(); showStep(2); showAlert(`Bitte vervollständige die Angaben für Karte ${invalid + 1}.`); return; }
    const senderName = sender.querySelector('[data-sender-name]').value.trim();
    const senderEmail = sender.querySelector('[data-sender-email]').value.trim();
    if (!senderName || !/^\S+@\S+\.\S+$/.test(senderEmail)) { showAlert('Bitte ergänze deinen Namen und eine gültige E-Mail-Adresse.'); return; }
    if (!sender.querySelector('[data-sender-privacy]').checked) { showAlert('Bitte bestätige die Datenschutzerklärung, um fortzufahren.'); return; }
    const submit = sender.querySelector('[data-sender-submit]');
    submit.disabled = true;
    submit.textContent = 'Shopify-Checkout wird vorbereitet …';
    const variantId = Number(sender.dataset.variantId);
    const items = recipients.map((recipient, index) => ({ id: variantId, quantity: 1, properties: { 'Karte': String(index + 1), 'Design': recipient.design, 'Empfänger': recipient.name, 'Firma': recipient.company, 'Adresse': [recipient.street, `${recipient.zip} ${recipient.city}`, recipient.country].filter(Boolean).join(', '), 'Versandtag': recipient.date, 'Persönliche Nachricht': recipient.message, '_Absender': senderName, '_Kontakt': senderEmail } }));
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error();
      window.location.assign('/checkout');
    } catch (_) {
      submit.disabled = false;
      submit.textContent = 'Personalisierte Karten sicher bestellen →';
      showAlert('Der Shopify-Checkout konnte nicht vorbereitet werden. Bitte versuche es erneut oder schreibe uns kurz.');
    }
  });
  updateTotals();
  renderRecipient();
})();

(() => {
  const quote = document.querySelector('[data-business-quote]');
  if (!quote) return;
  const form = quote.querySelector('form');
  if (!form || !quote.querySelector('[data-business-step]')) return;

  const alert = quote.querySelector('[data-business-alert]');
  const quantity = quote.querySelector('[data-business-quantity]');
  const details = quote.querySelector('[data-business-details]');
  const deadline = quote.querySelector('[data-business-deadline]');
  const company = quote.querySelector('[data-business-company]');
  const name = quote.querySelector('[data-business-name]');
  const email = quote.querySelector('[data-business-email]');
  const phone = quote.querySelector('[data-business-phone]');
  const privacy = quote.querySelector('[data-business-privacy]');
  const body = quote.querySelector('[data-business-quote-body]');
  let currentStep = 1;

  const selectedOccasion = () => quote.querySelector('input[name="business-occasion"]:checked')?.value || '';
  const selectedServices = () => [...quote.querySelectorAll('.business-service-grid input:checked')].map((input) => input.value);
  const showAlert = (message = '') => {
    if (!alert) return;
    alert.textContent = message;
    alert.hidden = !message;
  };
  const updateSummary = () => {
    const occasionNode = quote.querySelector('[data-business-summary-occasion]');
    const quantityNode = quote.querySelector('[data-business-summary-quantity]');
    const servicesNode = quote.querySelector('[data-business-summary-services]');
    if (occasionNode) occasionNode.textContent = selectedOccasion() || 'Anlass noch offen';
    if (quantityNode) quantityNode.textContent = `ca. ${Math.max(10, Number(quantity?.value) || 10)} Karten`;
    if (servicesNode) servicesNode.textContent = selectedServices().join(' · ') || 'Leistungen noch offen';
  };
  const showStep = (step) => {
    currentStep = step;
    quote.querySelectorAll('[data-business-step]').forEach((panel) => panel.classList.toggle('is-active', Number(panel.dataset.businessStep) === step));
    quote.querySelectorAll('[data-business-progress]').forEach((button) => {
      const number = Number(button.dataset.businessProgress);
      button.classList.toggle('is-active', number === step);
      button.disabled = number > step;
    });
    showAlert('');
    quote.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const validStep = (step) => {
    if (step === 1 && (!selectedOccasion() || Number(quantity?.value) < 10)) {
      showAlert('Bitte wähle einen Anlass und eine Menge ab 10 Karten.');
      return false;
    }
    if (step === 2 && !details?.value.trim()) {
      showAlert('Erzähl uns bitte kurz, was du dir für dein Projekt wünschst.');
      return false;
    }
    if (step === 3 && (!company?.value.trim() || !name?.value.trim() || !/^\S+@\S+\.\S+$/.test(email?.value || ''))) {
      showAlert('Bitte ergänze Unternehmen, Namen und eine gültige E-Mail-Adresse.');
      return false;
    }
    if (step === 3 && !privacy?.checked) {
      showAlert('Bitte bestätige die Datenschutzerklärung.');
      return false;
    }
    return true;
  };

  quote.querySelectorAll('[data-business-next]').forEach((button) => button.addEventListener('click', () => {
    if (!validStep(currentStep)) return;
    showStep(Number(button.dataset.businessNext));
  }));
  quote.querySelectorAll('[data-business-back]').forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.businessBack))));
  quote.querySelectorAll('[data-business-progress]').forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.businessProgress))));
  quote.querySelectorAll('input').forEach((input) => input.addEventListener('change', updateSummary));

  form.addEventListener('submit', (event) => {
    if (!validStep(1)) { event.preventDefault(); showStep(1); return; }
    if (!validStep(2)) { event.preventDefault(); showStep(2); return; }
    if (!validStep(3)) { event.preventDefault(); showStep(3); return; }
    if (body) body.value = [
      `Unternehmen: ${company.value.trim()}`,
      `Ansprechperson: ${name.value.trim()}`,
      `E-Mail: ${email.value.trim()}`,
      `Telefon: ${phone?.value.trim() || 'nicht angegeben'}`,
      `Anlass: ${selectedOccasion()}`,
      `Menge: ca. ${quantity.value} Karten`,
      `Leistungen: ${selectedServices().join(', ') || 'noch offen'}`,
      `Wunschtermin: ${deadline?.value || 'noch offen'}`,
      '',
      'Projektbeschreibung:',
      details.value.trim(),
    ].join('\n');
    const submit = quote.querySelector('[data-business-submit]');
    if (submit) { submit.disabled = true; submit.textContent = 'Anfrage wird gesendet …'; }
  });

  updateSummary();
})();
